import {use} from 'react';

import {ChartToolbarContext} from './ChartToolbarContext';

export function useChartToolbar() {
  const context = use(ChartToolbarContext);

  if (!context) {
    throw new Error('useChartToolbar must be used within ChartToolbarProvider');
  }

  return context;
}
